import { SET_ALL_DESKTOP_USERS, SET_DESKTOP_CLIENT_JSON, SET_DESKTOP_IS_CONNECTING, SET_DESKTOP_SHOW_MODAL } from '../../actionTypes/desktop'

export const setDesktopClientJson = value => ({ type: SET_DESKTOP_CLIENT_JSON, value })

export const setDesktopShowModal = value => ({ type: SET_DESKTOP_SHOW_MODAL, value })

export const setAllDesktopUsers = value => ({ type: SET_ALL_DESKTOP_USERS, value })

export const setDesktopIsConnecting = value => ({ type: SET_DESKTOP_IS_CONNECTING, value })
